/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Plan_Upgrade_DescInputs */



/**
* | output |
* | --- |
* | "This takes effect immediately. The new plan's pricing applies from now and a fresh credit pool is granted." |
*
* @param {Partner_Manage_Plan_Upgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_upgrade_desc = /** @type {((inputs?: Partner_Manage_Plan_Upgrade_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_Upgrade_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies wird sofort wirksam. Die Preise des neuen Tarifs gelten ab sofort und ein neues Guthaben wird gewährt.")
	return /** @type {LocalizedString} */ ("This takes effect immediately. The new plan's pricing applies from now and a fresh credit pool is granted.")
});